module.exports = __webpack_public_path__ + "media/images/icon__edit--rb-red@3x-b0c458f4b3907f3cd5d306f795767f37.png";